import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Date",
  "Webinar Name",
  "Webinar Status",
  "Webinar Start Time",
  "Webinar End Time",
  "Actions",
];
const AllWebinarTable = ({ PH = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();

  const goToView = (id) => {
    navigate(`/webinar/view/${id}`);
  };

  let today = new Date();
  const colourCode = (date) => {
    let webinarDate = new Date(date);
    let status = webinarDate >= today ? "upcoming" : "expired";
    if (status === "upcoming") {
      return "badge bg-green text-white";
    } else if (status === "expired") {
      return "badge bg-red text-white";
    }
  };
  const getStatus = (date) => {
    let webinarDate = new Date(date);
    let status = webinarDate >= today ? "Upcoming" : "Expired";
    return status;
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PH?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.webinarDate || "N/A"}</td>
                <td>{item?.webinarName || "N/A"}</td>
                <td>
                  <span className={colourCode(item?.webinarDate)}>
                    {getStatus(item?.webinarDate) || "N/A"}
                  </span>
                </td>
                <td>{item?.webinarStartTime || "N/A"}</td>
                <td>{item?.webinarEndTime || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllWebinarTable;
